import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import MoleculeAccount from "./MoleculeAccount";
import { useAtom } from "jotai";
import { palette } from "../../../../assets/styles/Palette";
import {
  PASSWORD,
  NEW_PASSWORD,
  RE_PASSWORD,
} from "../../../../pages/AtomStates";
import images from "../../../../assets/styles/Images";

const MoleculeAccountPopup = ({ onClose = () => {} }) => {
  const [, setPassword] = useAtom(PASSWORD);
  const [, setNewPassword] = useAtom(NEW_PASSWORD);
  const [, setRePassword] = useAtom(RE_PASSWORD);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 팝업 상태 관리

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      resetPasswordState();
      onClose();
    }
  };

  const resetPasswordState = () => {
    setPassword("");
    setNewPassword("");
    setRePassword("");
  };

  const handleClose = () => {
    resetPasswordState(); // 팝업 닫을 때 상태 초기화
    onClose(); // 팝업 닫기 함수 호출
  };

  const handleOpenPopup = () => {
    setIsPopupOpen(true); // 비밀번호 변경 성공 시 팝업 열기
  };

  const handleSuccessConfirm = () => {
    // 비밀번호 변경 성공 후 로그아웃 및 로그인 페이지로 이동
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/Login";
  };

  return (
    <>
      {!isPopupOpen ? ( // 팝업이 열려있지 않으면 렌더링
        <AccountPopupOverlay onClick={handleOverlayClick}>
          <PopupContent>
            <CloseButton onClick={handleClose}>닫기</CloseButton>
            <MoleculeAccount onOpenPopup={handleOpenPopup} /> {/* 비밀번호 변경 성공 시 팝업 열기 */}
          </PopupContent>
        </AccountPopupOverlay>
      ) : ( // 팝업이 열려있을 때 다른 요소들이 안 보이도록 조건부 렌더링
        <Popup onClick={handleClose}>
          <div>
            <span>
              <img src={images.CheckMark} alt="" />
            </span>
            <p>
              <strong>비밀번호가 변경되었습니다.</strong>
              <span>다시 로그인해주세요.</span>
            </p>
            <div className="btnWrap">
              <button type="button" onClick={handleSuccessConfirm}>
                확인
              </button>
            </div>
          </div>
        </Popup>
      )}
    </>
  );
};

export default MoleculeAccountPopup;

// CSS-in-JS 스타일링
const AccountPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const PopupContent = styled.div`
  position: relative;
  max-width: 690px;
  width: 100%;
  border-radius: 20px;
  padding: 64px 144px;
  background: ${palette.white};
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  font-family: "Pretendard", "Poppins";
  font-size: 1rem;
  color: ${palette.white};
  padding: 5px 26px 5px 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    top: 50%;
    right: 6px;
    width: 2px;
    height: 18px;
    border-radius: 5px;
    background: ${palette.white};
    content: "";
  }

  &:before {
    transform: translateY(-50%) rotate(45deg);
  }

  &:after {
    transform: translateY(-50%) rotate(-45deg);
  }
`;
const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
  z-index: 9999;

  > div {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    text-align: center;
    padding: 45px 24px 24px;
    border-radius: 10px;
    background: ${palette.white};

    span { display: flex; justify-content: center; }

    p {
      font-family: "Pretendard", "Poppins";
      font-size: 0.9375rem;
      font-weight: 600;
      margin: 16px auto 24px;
      strong { font-weight: 600; display: block; }
      span {
        font-size: 0.875rem;
        display: block;
        margin-top: 8px;
        color: ${palette.gray500};
      }
    }

    .btnWrap {
      display: flex;
      align-items: center;
      gap: 16px;
      padding-top: 16px;
      border-top: 1px solid ${palette.lineGray};

      button {
        margin: auto;
        font-family: "Pretendard", "Poppins";
        font-size: 0.875rem;
        font-weight: 600;
        color: ${palette.blue};
        padding: 0;
        border-radius: 0;
        border: 0;
        background: none;
      }
    }
  }
`;